export const PREFER_OLD_SITE_COOKIE = 'preferOldSite';

/** Session cookie so the old site is preferred only until the browser is closed, not until midnight. */
export function setPreferOldSiteUntilEndOfDay(): void {
  const parts = [
    `${PREFER_OLD_SITE_COOKIE}=1`,
    'path=/',
    'SameSite=Lax',
  ];

  if (window.location.protocol === 'https:') {
    parts.push('Secure');
  }

  document.cookie = parts.join('; ');
}
